import { WidgetConfig } from '@wix/da-gruser-shared/pkg/types/widget';
import ShopPremiumFolders from './ShopPremiumFolders';

export const getShopPremiumFoldersWidgetConfig = ({ t, dispatch }): WidgetConfig => ({
  viewComponent: ShopPremiumFolders,
});
